<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/m3.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Guarantee rules</div>
      </div>
    </div>
    <div class="floor2">
      <div class="title_txt">
        There are two ways to guarantee, one is 100%fully self-guarantee, the
        other is to invite the group members to guarantee 50%self-guarantee
        50%group members-guarantee
      </div>
      <div class="list">
        <div class="list1_item">Guarantee</div>
        <div class="list1_item">Self-guarantee</div>
        <div class="list1_item">Joint guarantee</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">Myself</div>
        <div class="list3_item">1</div>
        <div class="list3_item">1</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">My guarantee ratio</div>
        <div class="list3_item">100%</div>
        <div class="list3_item">50%</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">Group member</div>
        <div class="list3_item">0</div>
        <div class="list3_item">1-7 members</div>
      </div>
      <div class="list list_line">
        <div class="list2_item h52">Guarantee ratio of group members</div>
        <div class="list3_item h52">0</div>
        <div class="list3_item h52">50%</div>
      </div>
      <div class="list">
        <div class="list2_item h88">Guarantee period</div>
        <div class="list3_item h88">
          Loan period,<br />
          from the loan<br />
          application to pay off the loan
        </div>
        <div class="list3_item h88">
          Loan period,<br />
          from the loan <br />
          application toay off the loan
        </div>
      </div>
    </div>
    <div class="floor3">
      <div class="title1">A representative example of the loan guarantee</div>
      <div class="title2">
        Loan amount - Ksh 3,000; loan term -
        {{ IsTest ? "6 months" : "12 weeks" }}; You need to freeze the deposit
        of 1500 shillings (base on your credit)and unfreeze the deposit after
        the loan is paid off.If the loan is not repaid in time, we will deduct
        it from your guarantee caution money.
      </div>
      <div class="list">
        If you choose 100% self-guarantee, then you need to guarantee 1500
        shillings (based on your credit), and the guarantee period is
        {{ IsTest ? "6 months" : "12 weeks" }}.Guaranteed deposits normally pay
        monthly interest
      </div>
      <div class="list">
        If you choose 50%self-guarantee 50%members-guarantee, then you need to
        guarantee 750 shillings (based on your credit),your group members need
        to guarantee shillings 750
      </div>
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
import axios from "@/http/axios";
export default {
  data() {
    return {
      IsTest: true,
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
      return false;
    }
    sessionStorage.setItem("token", o.token);
    axios.post("/api/appgateway/user/getUserInfo", {}).then((res) => {
      if (res.code == "00000") {
        this.IsTest = res.data.userType == "99";
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 96px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #ecf7ff 0%,
      rgba(236, 247, 255, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 44px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .floor2 {
    position: relative;
    z-index: 100;
    margin: 0 16px;
    .title_txt {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      margin-bottom: 16px;
    }
    .list {
      display: flex;
      &.list_line {
        border-bottom: 1px solid #e9eff5;
      }
      .list1_item {
        background: #daf0ff;
        display: flex;
        flex: 1;
        font-size: 11px;
        font-family: "rm";
        font-weight: 500;
        color: #303f49;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
      }
      .list2_item {
        font-size: 11px;
        font-family: "rm";
        font-weight: 500;
        color: #303f49;
        background: #f2faff;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
        display: flex;
        flex: 1;
        &.h52 {
          height: 52px;
        }
        &.h88 {
          height: 88px;
        }
      }
      .list3_item {
        font-size: 11px;
        font-family: "rm";
        font-weight: 400;
        color: #50616c;
        background: #ffffff;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
        display: flex;
        flex: 1;
        &.h52 {
          height: 52px;
        }
        &.h88 {
          height: 88px;
        }
      }
    }
  }
  .floor3 {
    padding: 24px 16px;
    margin: 16px 16px 0;
    background: #ffffff;
    border-radius: 2px;
    .title1 {
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
    }
    .title2 {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      margin: 24px 0 16px;
    }
    .list {
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      position: relative;
      padding-left: 12px;
      margin-bottom: 12px;
      &::before {
        content: " ";
        position: absolute;
        left: 0;
        top: 9px;
        width: 5px;
        height: 5px;
        background: #d8d8d8;
        border-radius: 100%;
      }
    }
  }
}
</style>
